import React, { useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { MdClose } from 'react-icons/md';
import VideoEmbed from './VideoEmbed';

const ProjectModal = ({ isOpen, onRequestClose, selectedProject }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isOpen && videoRef.current) {
      videoRef.current.internalPlayer.playVideo();
      videoRef.current.internalPlayer.focus();
    }
  }, [isOpen]);

  // const handleVideoReady = (event) => {
  //   const player = event.target;
  //   if (player && player.playVideo) {
  //     player.playVideo();
  //     player.getIframe().focus();
  //   }
  // };

  const styles = {
    modalStyles: {},
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '0',
      marginLeft: '10px',
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={styles.modalStyles}
    >
      <div style={styles.modalHeader}>
        <h2>{selectedProject.title}</h2>
        <button style={styles.closeButton} onClick={onRequestClose}>
          <MdClose size={24} />
        </button>
      </div>
      <h3>Description</h3>
      <p>{selectedProject.description}</p>
      <h3>Tech</h3>
      <p>{selectedProject.tech}</p>

      {selectedProject.courseName && (
        <p>
          ---*---This is part of the coursework: {selectedProject.courseName}{' '}
          ---*---
        </p>
      )}

      {selectedProject.specialLink &&
        selectedProject.title === 'iOS Engineer - Internship @ Diall' && (
          <div>
            <h3>App Link</h3>
            <p>
              <i>Visit the app store to view the iOS app that I developed: </i>
              <a href={selectedProject.specialLink}>
                {selectedProject.specialLink}
              </a>
            </p>
          </div>
        )}
      <h4>Category</h4>
      <p>{selectedProject.category && selectedProject.category.join(', ')}</p>

      {/* {selectedProject.link && (
        <div>
          <h3>Link:</h3>
          <p>{selectedProject.link}</p>
        </div>
      )} */}
      {selectedProject.demo && (
        <div>
          <h3>Demo:</h3>
          {/* <YouTube
            videoId={selectedProject.demo}
            onReady={handleVideoReady}
            tabIndex={0}
          /> */}

          <VideoEmbed videoUrl={selectedProject.demo} />
          {/* <YouTube
            videoId={selectedProject.demo}
            onReady={(event) => (videoRef.current = event.target)}
          /> */}
        </div>
      )}
    </Modal>
  );
};

export default ProjectModal;
